export const direction = { portrait: "vertical", landscape: "horizontal" };
